"use client";

import { useSyncExternalStore } from "react";
import { getDueDateState } from "@/lib/due-date";

const subscribe = () => () => {};
const browserTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
const serverTimeZone = () => null;

/** Defer timezone-dependent deadline state until the browser has hydrated. */
export function useLocalDueDate(value) {
  const timeZone = useSyncExternalStore(subscribe, browserTimeZone, serverTimeZone);
  return timeZone ? getDueDateState(value, timeZone) : null;
}
